import React from "react";
// import { useHistory } from "react-router-dom";
import Card from "react-credit-cards";

import {
  formatCreditCardNumber,
  formatCVC,
  formatExpirationDate,
} from "./utils";
import styles from "./styles.css";

import "react-credit-cards/es/styles-compiled.css";

export default class App extends React.Component {
    routeChange=()=> {
        let path = `/`;
        // let history = useHistory();
        this.props.history.push(path);
      }
  render() {
  
    return (
      <div   >
      <h1><br />
        getCredit  <br />
        </h1>
        <div className="App-payment">
           
          <Card
            number="4321********1234"
            name="Johnny John"
            expiry="3099"
            cvc="123"
            focused="number"
           
          />
         
        <h1><br />
    
        404 - Sorry, this page does not exist<br /></h1>
<h2>
Easy to use<br />
Free use<br />
Secure data<br /><br />
</h2>
<button className="btn btn-primary btn-block" onClick={()=>{ this.props.history.push('/');}}>back to home</button>

        
         
        </div>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/404.js